import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip } from "reactstrap";
import moment from 'moment';
import 'moment-timezone';
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Dropzone from "react-dropzone";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import AsyncSelect from 'react-select/async';

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import FormData from 'form-data'
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetVendorState, getVendor } from "../../../store/vendor/action";
import { resetShipmentMethodState, getShipmentMethod, addNewShipmentMethod } from "../../../store/shipmentMethod/action";
import { resetShipmentCarrierState, getShipmentCarrier, addNewShipmentCarrier } from "../../../store/shipmentCarrier/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { resetAssetState, getAsset } from "../../../store/asset/action";
import { resetBranchState, getBranch } from "../../../store/branch/action";
import { deleteFile } from "../../../store/file/action";
import { resetTransferState, getTransfer as onGetTransfers, addNewTransfer as onAddNewTransfer, updateTransfer as onUpdateTransfer, deleteTransfer as onDeleteTransfer, getTransferLoading, resetTransferCreateState } from "../../../store/transfer/action";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import lottie from 'lottie-web';
import { defineElement } from 'lord-icon-element';
defineElement(lottie.loadAnimation);

const Transfer = () => {
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [customActiveTab, setCustomActiveTab] = useState("1");
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setCustomActiveTab(tab);
    }
  };
  const dispatch = useDispatch();

  const { transfers, transferAdded, isTransferCreated, isTransferSuccess, loading, error, employees, employeeLoading,
    companies, companyLoading, shipmentMethods, shipmentMethodLoading, shipmentCarriers, shipmentCarrierLoading,
    branches, branchLoading, productVarians, productVarianLoading, assets, assetLoading,
    departments, departmentLoading } = useSelector((state) => ({
      transferAdded: state.Transfer.transferAdded,
      transfers: state.Transfer.transfers,
      isTransferCreated: state.Transfer.isTransferCreated,
      isTransferSuccess: state.Transfer.isTransferSuccess,
      loading: state.Transfer.loading,
      companies: state.Company.companies,
      companyLoading: state.Company.loading,
      paymentMethods: state.PaymentMethod.paymentMethods,
      paymentMethodLoading: state.PaymentMethod.loading,
      employees: state.Employee.employees,
      employeeLoading: state.Employee.loading,
      shipmentMethods: state.ShipmentMethod.shipmentMethods,
      shipmentMethodLoading: state.ShipmentMethod.loading,
      vendors: state.Vendor.vendors,
      vendorLoading: state.Vendor.loading,
      branches: state.Branch.branches,
      branchLoading: state.Branch.loading,
      accAccounts: state.AccAccount.accAccounts,
      accAccountLoading: state.AccAccount.loading,
      shipmentCarriers: state.ShipmentCarrier.shipmentCarriers,
      shipmentCarrierLoading: state.ShipmentCarrier.loading,
      productVarians: state.ProductVarian.productVarians,
      productVarianLoading: state.ProductVarian.loading,
      assets: state.Asset.assets,
      assetLoading: state.Asset.loading,
      error: state.Transfer.error,
    }));

  const [transferList, setTransferList] = useState([]);
  const [transfer, setTransfer] = useState([]);
  const [info, setInfo] = useState([]);
  const [transferType, setTransferType] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusTransfer, setStatusTransfer] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [shipmentMethodList, setShipmentMethodList] = useState([]);
  const [shipmentCarrierList, setShipmentCarrierList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [originalFiles, setOriginalFiles] = useState([]);
  const [productList, setProductList] = useState([]);
  const [assetList, setAssetList] = useState([]);
  const [transferDetailItem, setTransferDetailItem] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const statusTransferData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "Pending", value: "2" },
        { label: "Confirmed", value: "3" },
        { label: "Processed", value: "4" },
        { label: "Completed", value: "5" },
        { label: "Canceled", value: "8" },
        { label: "Returned", value: "9" },
      ],
    }];

  const transferTypeData = [
    {
      options: [
        { label: "Asset", value: "Asset" },
        { label: "Product", value: "Product" },
      ],
    }];

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredTransfers = transfers;
      if (type !== "all") {
        filteredTransfers = transfers.filter((transfer) => transfer.transfer_status.name === type);
      }
      setTransferList(filteredTransfers);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setTransferList(transfers);
  }, [transfers]);

  useEffect(() => {
    if (!isSearch) {
      dispatch(resetTransferState());
      dispatch(onGetTransfers({ "type": "Product" }));
      setIsSearch(true);
      setIsEdit(false);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (
        obj.data &&
        obj?.data?.user?.user_position &&
        obj?.data?.user?.user_position?.position_role
      ) {
        setRoles(obj?.data?.user?.user_position?.position_role.method);
      }
      if (obj?.data)
        setUserType(obj?.data?.userType);
    }
  }, [dispatch, transfers, isSearch]);

  useEffect(() => {
    setTransfer(transferAdded);
  }, [transferAdded]);

  useEffect(() => {
    if (!isEmpty(transferAdded)) {
      setTransfer(transferAdded);
    }
  }, [transferAdded]);

  useEffect(() => {
    if (!isEmpty(transfers)) {
      setTransferList(transfers);
      setInfo(transfers[transfers.length - 1]);
    }
  }, [transfers]);

  const handleValidDate = date => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  useEffect(() => {
    if (companies && !companies.length) {
      dispatch(resetCompanyState());
      dispatch(getCompany());
    }
  }, [dispatch, companies]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  const promiseProductOptions = (e) => {
    if (!productVarianLoading) {
      dispatch(resetProductVarianState());
      setProductList([]);
      if (e.length > 1) {
        dispatch(getProductVarian({ "type": "referral", "title": e }));
      }
      return new Promise((resolve, reject) => {
        while (productVarianLoading);
        resolve(productList);
      });
    }
  }

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var opt = [];
      productVarians.forEach((item, key) => {
        const varian_name = item.pvar_product.product_name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const price = item.price;
        const brandId = item.brandId;
        const productId = item.productId;
        let option_name = "";
        item.pvar_options && item.pvar_options.forEach((i, k) => {
          option_name += i.detail_name + "/"
        })

        var obj = { label: varian_name + " " + option_name.slice(0, -1) + " - " + barcode, name: varian_name + " " + option_name.slice(0, -1), barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId };
        opt.push(obj);
      })
      var option = { options: opt }
      productVarianData.push(option);
      setProductList(productVarianData);
    }
  }, [productVarians]);

  const promiseAssetOptions = (e) => {
    if (!assetLoading) {
      dispatch(resetAssetState());
      setAssetList([]);
      if (e.length > 1) {
        dispatch(getAsset({ "type": "referral", "title": e }));
      }
      return new Promise((resolve, reject) => {
        while (assetLoading);
        resolve(assetList);
      });
    }
  }

  useEffect(() => {
    if (!isEmpty(assets)) {
      var assetData = [];
      var opt = [];
      assets.forEach((item, key) => {
        const name = item.asset_name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const price = item.price;
        const brandId = item.brandId;
        var obj = { label: name + " - " + barcode, name: name, barcode: barcode, sku: sku, value: id, price: price, brandId: brandId };
        opt.push(obj);
      })
      var option = { options: opt }
      assetData.push(option);
      setAssetList(assetData);
    }
  }, [assets]);

  useEffect(() => {
    if (shipmentCarriers && !shipmentCarriers.length && !isSearch) {
      dispatch(getShipmentCarrier());
    }
  }, [dispatch, shipmentCarriers, isSearch]);

  useEffect(() => {
    if (!isEmpty(shipmentCarriers)) {
      var data = [];
      var opt = [];
      shipmentCarriers.forEach((item, key) => {
        const carrier_name = item.carrier_name;
        const id = item.id;
        var obj = { label: carrier_name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setShipmentCarrierList(data);
    }
  }, [shipmentCarriers]);

  useEffect(() => {
    if (shipmentMethods && !shipmentMethods.length && !isSearch) {
      dispatch(getShipmentMethod());
    }
  }, [dispatch, shipmentMethods, isSearch]);

  useEffect(() => {
    if (!isEmpty(shipmentMethods)) {
      var data = [];
      var opt = [];
      shipmentMethods.forEach((item, key) => {
        const method_name = item.method_name;
        const id = item.id;
        var obj = { label: method_name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setShipmentMethodList(data);
    }
  }, [shipmentMethods]);

  useEffect(() => {
    if (employees && !employees.length && !isSearch) {
      dispatch(resetEmployeeState());
      dispatch(getEmployee({ type: "referral", status: 2 }));
    }
  }, [employees, isSearch, dispatch]);

  useEffect(() => {
    if (!isEmpty(employees)) {
      var data = [];
      var opt = [];
      employees.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const taskListId = item.taskListId;
        const positionId = item.positionId
        const position_name = item.employee_position && item.employee_position.name ? item.employee_position.name : "Not set";
        var obj = { label: name + " - " + position_name, value: id, taskListId: taskListId, positionId: positionId };
        opt.push(obj);
      })
      var option = { options: opt }
      data.push(option);
      setEmployeeList(data);
    }
  }, [employees]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const branch_name = item.branch_name;
        const id = item.id;
        var obj = { label: branch_name, value: id };
        opt.push(obj);
      })
      var option = { options: opt }
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  const onClickDelete = (transfer) => {
    setTransfer(transfer);
    setDeleteModal(true);
  };

  const handleDeleteTransfer = () => {
    if (transfer) {
      dispatch(onDeleteTransfer(transfer));
      setDeleteModal(false);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setTransfer(null);
      setSelectedFiles([]);
      setOriginalFiles([]);
      setTransferDetailItem([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setTransfer(null);
      setTransferDetailItem([]);
      setSelectedFiles([]);
      setOriginalFiles([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const toggleApprove = useCallback(() => {
    if (modalApprove) {
      setModalApprove(false);
    } else {
      setModalApprove(true);
    }
  }, [modalApprove]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);


  const [subTotal, setSubTotal] = useState(0);
  const [ship, setShip] = useState(0);

  const handleInvoiceClick = (arg) => {
    const transfer = arg;
    let transferDetail = [];
    let sub_total = 0;

    setShip(parseInt(transfer.shipment_amount || 0));

    setTransferType(transfer.transfer_type);
    if (transfer.transfer_detail) {
      transfer.transfer_detail.forEach(element => {
        sub_total += parseInt(element.quantity) * parseInt(element.amount);
        transferDetail.push({
          detailId: element.id,
          itemId: transfer.transfer_type === "Product" ? element.productVarianId : element.assetId,
          item: transfer.transfer_type === "Product" ? { label: element.item_name, value: element.productVarianId, name: element.item_name, sku: element.sku, barcode: element.barcode, price: element.amount, brandId: element.brandId, productId: element.productId } : { label: element.item_name, value: element.assetId, name: element.item_name, sku: element.sku, barcode: element.barcode, price: element.amount, brandId: element.brandExtId },
          amount: Math.round(element.amount, 0),
          quantity: Math.round(element.quantity, 0),
          total: Math.round(element.amount_total, 0),
          name: element.item_name,
          sku: element.sku,
          barcode: element.barcode,
          brandId: transfer.transfer_type === "Product" ? element.brandId : element.brandExtId,
          accepted: element.accepted ? Math.round(element.accepted, 0) : 0,
          rejected: element.rejected ? Math.round(element.rejected, 0) : 0,
        });
      });
      setTransferDetailItem(transferDetail);
      setSubTotal(sub_total);
    }
    let files = [];
    for (const f of transfer.transfer_file) {
      files.push({ filename: f.filename, originalname: f.originalname })
    }
    setOriginalFiles(files);
  }

  const handleTransferClick = useCallback((arg) => {
    const transfer = arg;
    let transferDetail = [];

    setTransferType(transfer.transfer_type);
    if (transfer.transfer_detail) {
      transfer.transfer_detail.forEach(element => {
        transferDetail.push({
          detailId: element.id,
          itemId: transfer.transfer_type === "Product" ? element.productVarianId : element.assetId,
          item: transfer.transfer_type === "Product" ? { label: element.item_name, value: element.productVarianId, name: element.item_name, sku: element.sku, barcode: element.barcode, price: element.amount, brandId: element.brandId, productId: element.productId } : { label: element.item_name, value: element.assetId, name: element.item_name, sku: element.sku, barcode: element.barcode, price: element.amount, brandId: element.brandExtId },
          amount: Math.round(element.amount, 0),
          quantity: Math.round(element.quantity, 0),
          quantity_available: transfer.transfer_type === "Product" ? Math.round(Number(element.transfer_branch_product_inv.stocks) - Number(element.transfer_branch_product_inv.allocated) + Number(element.quantity), 0) : Math.round(element.quantity, 0),
          total: Math.round(element.amount_total, 0),
          name: element.item_name,
          sku: element.sku,
          barcode: element.barcode,
          brandId: transfer.transfer_type === "Product" ? element.brandId : element.brandExtId,
          accepted: element.accepted ? Math.round(element.accepted, 0) : 0,
          rejected: element.rejected ? Math.round(element.rejected, 0) : 0,
        });
      });
      setTransferDetailItem(transferDetail);
    }

    let files = [];
    for (const f of transfer.transfer_file) {
      files.push({ filename: f.filename, originalname: f.originalname })
    }
    setOriginalFiles(files);
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: transfer.companyId, status: 2 }));

    setTransfer({
      id: transfer.id,
      transactionat: transfer.transactionat,
      discount: transfer.disc_amount || 0,
      description: transfer.description,
      shipment_amount: transfer.shipment_amount,
      shipment_carrier: transfer.transfer_shipment_carrier && { label: transfer.transfer_shipment_carrier.carrier_name, value: transfer.transfer_shipment_carrier.id },
      shipment_method: transfer.transfer_shipment_method && { label: transfer.transfer_shipment_method.method_name, value: transfer.transfer_shipment_method.id },
      transaction_no: transfer.transaction_no,
      transfer_type: transfer.transfer_type && { label: transfer.transfer_type, value: transfer.transfer_type },
      department: transfer.transfer_department && { label: transfer.transfer_department.name, value: transfer.transfer_department.id },
      transaction_reff: transfer.transaction_reff,
      branch: transfer.transfer_to && { label: transfer.transfer_to.branch_name, value: transfer.transfer_to.id },
      company: transfer.transfer_company && transfer.transfer_company.name && { label: transfer.transfer_company.name, value: transfer.transfer_company.id },
      status: transfer.transfer_status && { label: transfer.transfer_status.name, value: transfer.transfer_status.id },
      statusTransferId: transfer.statusTransferId,
    });

    setIsEdit(true);
    toggle();
  }, [dispatch, toggle]);

  function currencyFormat(num) {
    return 'Rp ' + parseFloat(num).toLocaleString(['ban', 'id'])
  }

  const columns = useMemo(() => [{
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
    Cell: (cellProps) => {
      return <input type="checkbox" className="dataCheckbox form-check-input" value={cellProps.row.original.id} />;
    },
    id: '#',
  },
  {
    Header: "Invoice No",
    accessor: "transaction_no",
    filterable: true,
    Cell: (cellProps) => (
      <Link to="#" className="fw-semibold" onClick={() => {
        let data = cellProps.row.original;
        handleInvoiceClick(data);
        setInfo(data);
        setModalDetail(true);
      }}>{cellProps.row.original.transaction_no}</Link>),
  },
  {
    Header: "Transfer From",
    accessor: "transfer_from.branch_name",
    filterable: true,
  },
  {
    Header: "Transfer To",
    accessor: "transfer_to.branch_name",
    filterable: true,
  },
  {
    Header: "Date",
    accessor: "transactionat",
    filterable: false,
    Cell: (data) => { return handleValidDate(data.row.original.transactionat) }
  },
  {
    Header: "Quantity",
    accessor: "sub_amount",
    filterable: true,
    Cell: (data) => {
      let qty = 0;
      data.row.original.transfer_detail.forEach(element => {
        qty += parseInt(element.quantity);
      });
      return (<span>{Math.round(qty, 0)}</span>)
    },
  },
  {
    Header: "Status",
    accessor: "transfer_status.name",
    filterable: true,
    Cell: (cell) => {
      switch (cell.value) {
        case "DRAFT":
          return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
        case "Pending":
          return <span className="badge text-uppercase badge-soft-secondary">{cell.value}</span>;
        case "CONFIRMED":
          return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
        case "PROCESSED":
          return <span className="badge text-uppercase badge-soft-primary">{cell.value}</span>;
        case "Shipped":
          return <span className="badge text-uppercase badge-soft-primary">{cell.value}</span>;
        case "COMPLETED":
          return <span className="badge text-uppercase badge-soft-success">{cell.value}</span>;
        default:
          return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
      }
    }
  },
  {
    Header: " ",
    filterable: false,
    Cell: (cellProps) => {
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0">
          <Link to="#" className="btn-icon btn btn-sm btn-light" onClick={() => {
            let data = cellProps.row.original;
            handleInvoiceClick(data);
            setInfo(data);
            setModalDetail(true);
          }}><i className="ri-eye-line fs-15"></i>
          </Link>
          <Link to="#" className="btn-icon btn btn-sm btn-light" onClick={() => {
            let data = cellProps.row.original;
            setInfo(data);
            toggleHistory();
          }}><i className=" ri-history-line fs-15"></i>
          </Link>
          {cellProps.row.original.statusId < 3 && (
            <Link to="#" className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
              onClick={() => {
                let data = cellProps.row.original;
                onClickDelete(data);
              }}><i className="ri-delete-bin-line fs-15 text-danger"></i>
            </Link>
          )}
          {cellProps.row.original.statusId === 1 && (
            <button className="btn-label btn btn-sm btn-soft-success fs-12 me-0"
              onClick={() => {
                let data = cellProps.row.original;
                data.statusTransferId = 2;
                handleTransferClick(data);
              }}> <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Confirm</button>
          )}
          {cellProps.row.original.statusId === 2 && (
            <button className="btn-label btn btn-sm btn-soft-success fs-12 me-0"
              onClick={() => {
                let data = cellProps.row.original;
                data.statusTransferId = 3;
                setTransfer(data);
                toggleApprove();
              }}> <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Processed</button>
          )}
          {cellProps.row.original.statusId === 3 && (
            <button className="btn-label btn btn-sm btn-soft-success fs-12 me-0"
              onClick={() => {
                let data = cellProps.row.original;
                data.statusTransferId = 4
                setTransfer(data);
                toggleApprove();
              }}> <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Shipped</button>
          )}
        </div>
      );
    },
  },
  ], [handleTransferClick, toggleApprove, toggleHistory]);

  const { getTableProps, rows, getTableBodyProps, headerGroups, page, prepareRow, canPreviousPage, canNextPage, pageOptions, gotoPage, nextPage, previousPage, setPageSize, preGlobalFilteredRows, setGlobalFilter, state: { pageIndex, pageSize } } = useTable(
    {
      columns: columns,
      data: transferList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0, pageSize: 10, selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  function handleFilter() {
    let startat = '';
    let endat = '';
    let datearr = filterDate.split(' to ');
    if (datearr[1]) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusTransfer.value ? statusTransfer.value : '';
    const param = {
      "title": searchValue,
      "startat": startat,
      "endat": endat,
      "status": status,
      "type": "purchasing"
    }
    dispatch(onGetTransfers(param));
  }

  const validationApprove = useFormik({
    enableReinitialize: true,
    initialValues: {
      approval_note: "",
    },
    onSubmit: (values) => {
      if (transfer) {
        transfer.setApprove = true;
        transfer.approval_note = values.approval_note;
        dispatch(onUpdateTransfer(transfer));
      }
      validationApprove.resetForm();
      toggleApprove();
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (transfer && transfer.id) || 0,
      dueat: (transfer && transfer.dueat) || '',
      transactionat: (transfer && transfer.transactionat) || '',
      description: (transfer && transfer.description) || '',
      transaction_no: (transfer && transfer.transaction_no) || '',
      transaction_reff: (transfer && transfer.transaction_reff) || '',
      branch: (transfer && transfer.branch),
      company: (transfer && transfer.company),
      shipment_carrier: (transfer && transfer.shipment_carrier),
      shipment_method: (transfer && transfer.shipment_method),
      shipment_amount: (transfer && transfer.shipment_amount) || 0,
      status: (transfer && transfer.status),
      transfer_type: (transfer && transfer.transfer_type),
    },
    validationSchema: Yup.object({
      company: Yup.object().required("Please enter company").nullable(true),
      transfer_type: Yup.object().required("Please enter transfer type").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getTransferLoading());
      if (isEdit) {
        let formData = new FormData();
        if (values.files && values.files.length) {
          for (let i = 0; i < values.files.length; i++) {
            formData.append("files", values.files[i]);
          }
        }
        formData.append('id', values.id);
        formData.append('statusTransferId', transfer.statusTransferId);
        formData.append('transfer_type', values.transfer_type && values.transfer_type.value);
        formData.append('transaction_no', values.transaction_no);
        formData.append('transaction_reff', values.transaction_reff);
        formData.append('transactionat', values.transactionat);
        formData.append('description', values.description);
        formData.append('companyId', values.company && values.company.value);
        formData.append('departmentId', values.department && values.department.value);
        formData.append('branchId', values.branch && values.branch.value);
        formData.append('shipmentCarrierId', values.shipment_carrier && values.shipment_carrier.value);
        formData.append('shipmentMethodId', values.shipment_method && values.shipment_method.value);
        formData.append('shipment_amount', values.shipment_amount);
        if (transferDetailItem && transferDetailItem.length) {
          formData.append("transfer_detail", JSON.stringify(transferDetailItem));
        }
        dispatch(onUpdateTransfer(formData));
      } else {
        let formData = new FormData();
        if (values.files && values.files.length) {
          for (let i = 0; i < values.files.length; i++) {
            formData.append("files", values.files[i]);
          }
        }
        formData.append('statusTransferId', transfer.statusTransferId);
        formData.append('transfer_type', values.transfer_type && values.transfer_type.value);
        formData.append('transaction_no', values.transaction_no);
        formData.append('transaction_reff', values.transaction_reff);
        formData.append('transactionat', values.transactionat);
        formData.append('description', values.description);
        formData.append('companyId', values.company && values.company.value);
        formData.append('departmentId', values.department && values.department.value);
        formData.append('branchId', values.branch && values.branch.value);
        formData.append('shipmentCarrierId', values.shipment_carrier && values.shipment_carrier.value);
        formData.append('shipmentMethodId', values.shipment_method && values.shipment_method.value);
        formData.append('shipment_amount', values.shipment_amount);
        if (transferDetailItem && transferDetailItem.length) {
          formData.append("transfer_detail", JSON.stringify(transferDetailItem));
        }
        dispatch(onAddNewTransfer(formData));
      }
      validation.resetForm();
      toggle();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");
    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteTransfer(element.value));
    });
    checkall.checked = false;
  };


  function handleTransferDetailAdd() {
    let fc = [];
    if (transferDetailItem && transferDetailItem.length) {
      transferDetailItem.forEach(element => {
        fc.push(element);
      });
    }
    fc.push({
      detailId: null,
      itemId: null,
      item: {},
      amount: 0,
      quantity: 0,
      total: 0,
      sku: null,
      barcode: null,
      brandId: null,
    });
    setTransferDetailItem(fc);
  }

  const onClickDeleteDetailItem = (detail) => {
    const object = transferDetailItem.findIndex((obj) => obj.detailId === detail.detailId);
    if (object > -1) {
      transferDetailItem.splice(object, 1);
    }
  };

  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size)
      })
    );
    setSelectedFiles(files);
    validation.setFieldValue("files", files);
  }

  function handleDeleteFiles(filesId) {
    const object = originalFiles.findIndex((obj) => obj.id === filesId);
    if (object > -1) {
      dispatch(deleteFile({ id: filesId }));
      originalFiles.splice(object, 1);
    }
  }

  function handleDeleteUploadedFiles(filesId) {
    const object = selectedFiles.findIndex((obj, idx) => idx === filesId);
    if (object > -1) selectedFiles.splice(object, 1);
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  function printInvoice(ele) {
    var domClone = ele.cloneNode(true);
    var printSection = document.getElementById("printSection");
    if (!printSection) {
      printSection = document.createElement("div");
      printSection.id = "printSection";
      document.body.appendChild(printSection);
    }
    printSection.innerHTML = "";
    printSection.appendChild(domClone);
    window.print();
    return false
  }

  document.title = "Distribution | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={transferList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteTransfer} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal show={deleteModalMulti}
        onDeleteClick={() => { deleteMultiple(); setDeleteModalMulti(false); }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Distribution" pageTitle="Sales" />
        <Row>
          <Col xxl={12}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Distribution History &nbsp;{isLoading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}> Loading... </Spinner>&nbsp;
                        <Spinner color="success" type="grow" size={"sm"}> Loading... </Spinner>&nbsp;
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button type="button" className="btn btn-success me-1" onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i>  Export
                    </button>  <button className="btn btn-soft-danger" onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete</button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist" >
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "1" }, "fw-semibold")} onClick={() => { toggleTab("1", "all"); }} href="#">
                        <i className=" ri-group-line me-1 align-bottom fs-14"></i>  All Distribution
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "2" }, "fw-semibold")} onClick={() => { toggleTab("2", "DRAFT"); }} href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>  DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "3" }, "fw-semibold")} onClick={() => { toggleTab("3", "Pending"); }} href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>  Pending
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "4" }, "fw-semibold")} onClick={() => { toggleTab("4", "Confirmed"); }} href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>  Confirmed    </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "5" }, "fw-semibold")} onClick={() => { toggleTab("5", "Processed"); }} href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>  Processed    </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "6" }, "fw-semibold")} onClick={() => { toggleTab("6", "Completed"); }} href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>  Completed
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-3 col-12">
                              <select className="form-select"
                                value={pageSize} onChange={onChangeInSelect}> {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>{pageSize}</option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="search-box me-2 mb-3 d-inline-block col-12">
                              <input id="search-bar-0" type="text" className="form-control search"
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                placeholder={`${countSearch} Search...`} value={searchValue ?? ""} />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr className="form-control" id="datepicker-publish-input" placeholder="Select publish date"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d"
                                }}
                                onChange={(selectedDates, dateStr) => { setFilterDate(dateStr); }} /><i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div>
                              <button type="button" className="btn btn-light w-100" onClick={() => { handleFilter(); }}>              <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>{"<"}</Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">Page    <strong>
                      {pageIndex + 1} of {pageOptions.length}
                    </strong>
                    </Col>
                    <Col className="col-md-auto">
                      <Input
                        type="number"
                        min={1}
                        style={{ width: 70 }}
                        max={pageOptions.length}
                        defaultValue={pageIndex + 1}
                        onChange={onChangeInInput}
                      />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>{!!isEdit ? "Edit Transfer" : "Add Transfer"}</ModalHeader>
                  <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); return false; }}>
                    <ModalBody>
                      <CardBody className="p-4">
                        <div className="table-responsive">
                          <Table className="invoice-table table-borderless table-nowrap mb-0">
                            <thead className="align-middle">
                              <tr className="table-active">
                                <th scope="col" style={{ width: "20px" }}>#</th>
                                <th scope="col">Detail Produk</th>
                                <th scope="col" style={{ width: "120px" }}>Rate</th>
                                <th scope="col" className="text-center" style={{ width: "100px" }}>Available</th>
                                <th scope="col" style={{ width: "150px" }}>Quantity</th>
                                <th scope="col" className="text-end" style={{ width: "150px" }}>Amount</th>
                                <th scope="col" className="text-end" style={{ width: "35px" }}></th>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {transferDetailItem.map((o, i) => {
                                return (
                                  <tr key={i} id={i} className="product">
                                    <th scope="row" className="product-id">{i + 1}</th>
                                    <td className="text-start">
                                      {transferType === "Product" && (
                                        <AsyncSelect name={`transferDetailItem.${i}.id`}
                                          value={transferDetailItem[i].item || {}}
                                          placeholder="Enter Product"
                                          onChange={(e) => {
                                            validation.setFieldValue(`transferDetailItem.${i}.id`, e);
                                            transferDetailItem[i].item = e;
                                            transferDetailItem[i].sku = e.sku;
                                            transferDetailItem[i].barcode = e.barcode;
                                            transferDetailItem[i].itemId = e.productVarianId;
                                            transferDetailItem[i].brandId = e.brandId;
                                            transferDetailItem[i].amount = Math.round(e.price, 0);
                                          }}
                                          cacheOptions
                                          loadOptions={promiseProductOptions}></AsyncSelect>
                                      )}
                                      {transferType === "Asset" && (
                                        <AsyncSelect name={`transferDetailItem.${i}.id`}
                                          value={transferDetailItem[i].item || {}}
                                          placeholder="Enter Asset"
                                          onChange={(e) => {
                                            validation.setFieldValue(`transferDetailItem.${i}.id`, e);
                                            transferDetailItem[i].item = e;
                                            transferDetailItem[i].sku = e.sku;
                                            transferDetailItem[i].barcode = e.barcode;
                                            transferDetailItem[i].brandId = e.brandId;
                                            transferDetailItem[i].itemId = e.assetId;
                                            transferDetailItem[i].amount = Math.round(e.price, 0);
                                          }}
                                          cacheOptions
                                          loadOptions={promiseAssetOptions}></AsyncSelect>
                                      )}
                                    </td>
                                    <td>
                                      <Input name={`transferDetailItem.${i}.amount`} placeholder="Price" type="text" className="form-control product-price" style={{ width: "180px" }}
                                        value={transferDetailItem[i].amount || 0}
                                        onChange={(e) => {
                                          validation.setFieldValue(`transferDetailItem.${i}.amount`, e.target.value);
                                          transferDetailItem[i].amount = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur} />
                                    </td>
                                    <td valign="middle" align="center">{transferDetailItem[i].quantity_available}</td>
                                    <td>
                                      <div className="input-step">
                                        <button type="button" className="minus" onClick={() => {
                                          transferDetailItem[i].quantity = transferDetailItem[i].quantity > 0 ? transferDetailItem[i].quantity - 1 : transferDetailItem[i].quantity;
                                          validation.setFieldValue(`transferDetailItem.${i}.quantity`, transferDetailItem[i].quantity);
                                        }}>–</button>
                                        <Input name={`transferDetailItem.${i}.quantity`} placeholder="Qty" type="text" className=" product-quantity border-0" style={{ width: "80px" }}
                                          value={transferDetailItem[i].quantity || 0}
                                          onChange={(e) => {
                                            let qty = e.target.value >= transferDetailItem[i].quantity_available ? transferDetailItem[i].quantity_available : e.target.value;
                                            validation.setFieldValue(`transferDetailItem.${i}.quantity`, qty);
                                            transferDetailItem[i].quantity = qty;
                                          }}
                                          onBlur={validation.handleBlur} />
                                        <button type="button" className="plus" onClick={() => {
                                          transferDetailItem[i].quantity = transferDetailItem[i].quantity >= transferDetailItem[i].quantity_available ? transferDetailItem[i].quantity_available : transferDetailItem[i].quantity + 1;
                                          validation.setFieldValue(`transferDetailItem.${i}.quantity`, transferDetailItem[i].quantity);
                                        }}>+</button>
                                      </div>
                                    </td>
                                    <td className="text-end">
                                      <div>
                                        <Input name={`transferDetailItem.${i}.total`} placeholder="Total" type="text" className="form-control product-line-price bg-light border-0" style={{ width: "180px" }}
                                          readOnly
                                          value={currencyFormat(transferDetailItem[i].amount * transferDetailItem[i].quantity)}
                                          onChange={(e) => { }}
                                          onBlur={validation.handleBlur} />
                                      </div>
                                    </td>
                                    <td className="product-removal">
                                      <Link to="#" className="text-danger btn-icon btn btn-soft-danger flex-shrink-0" onClick={() => {
                                        const data = transferDetailItem[i];
                                        onClickDeleteDetailItem(data);
                                      }}>
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                            <tbody>
                              <tr id="newForm" style={{ display: "none" }}><td className="d-none" colSpan="5"><p>Tambah Form</p></td></tr>
                              <tr>
                                <td colSpan="5">
                                  <Link to="#" className="btn btn-soft-success fw-medium" id="add-item" onClick={() => { handleTransferDetailAdd(); }}>
                                    <i className="ri-add-fill me-1 align-bottom"></i>Add Item
                                  </Link>
                                </td>
                              </tr>
                              <tr className="border-top border-top-dashed mt-2">
                                <td colSpan="3">
                                  <div className="mb-3">
                                    <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={4}
                                      value={validation.values.description ?? ""}
                                      onBlur={validation.handleBlur}
                                      onChange={validation.handleChange}
                                      invalid={validation.touched.description && validation.errors.description ? true : false} />
                                    {validation.touched.description && validation.errors.description && (
                                      <small className="text-danger" type="invalid">{validation.errors.description}</small>
                                    )}
                                  </div>
                                  <div>
                                    <Label htmlFor="address-field" className="form-label">Transfer Document</Label>
                                    <Dropzone onDrop={acceptedFiles => { handleAcceptedFiles(acceptedFiles); }}>
                                      {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone dz-clickable" style={{ cursor: "pointer", height: "140px", }} {...getRootProps({ className: "dropzone" })}>
                                          <div className="dz-message needsclick">
                                            <div>
                                              <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                              <input {...getInputProps()} />
                                            </div>
                                            <h5>Drop files here or click to upload.</h5>
                                          </div>
                                        </div>
                                      )}
                                    </Dropzone>
                                    <div className="list-unstyled mb-0" id="file-previews">
                                      {originalFiles.map((f, i) => {
                                        return (
                                          <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete" key={i + "-file"}>
                                            <div className="p-2 d-flex align-items-center">
                                              <Row className="flex-grow-1">
                                                <Col className="col-auto">
                                                  {f.mimetype.includes("image") ? (
                                                    <img data-dz-thumbnail="" height="80" className="avatar-sm rounded bg-light" alt={f.filename} src={process.env.REACT_APP_API_URL + "/files/" + f.path} />
                                                  ) : (<i className="display-6 text-muted ri-function-line" />)}
                                                </Col>
                                                <Col className="overflow-scroll">
                                                  <Link to="#" className="text-muted font-weight-bold" > {f.originalname} </Link>
                                                  <p className="mb-0"><strong>{formatBytes(f.size)}</strong></p>
                                                </Col>
                                              </Row>
                                              <Link to="#" className="text-danger btn-icon btn btn-sm btn-soft-danger flex-shrink-0" onClick={() => { handleDeleteFiles(f.id) }}>
                                                <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                              </Link>
                                            </div>
                                          </Card>
                                        );
                                      })}
                                      {selectedFiles.map((f, i) => {
                                        return (
                                          <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete" key={i + "-file"}>
                                            <div className="p-2 d-flex align-items-center">
                                              <Row className="flex-grow-1">
                                                <Col className="col-auto">
                                                  <img data-dz-thumbnail="" height="80" className="avatar-sm rounded bg-light" alt={f.name} src={f.preview} />
                                                </Col>
                                                <Col>
                                                  <Link to="#" className="text-muted font-weight-bold"> {f.name} </Link>
                                                  <p className="mb-0"><strong>{f.formattedSize}</strong></p>
                                                </Col>
                                              </Row>
                                              <Link to="#" className="text-danger btn-icon btn btn-sm btn-soft-danger flex-shrink-0" onClick={() => { handleDeleteUploadedFiles(i) }}>
                                                <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                              </Link>
                                            </div>
                                          </Card>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </td>
                                <td></td>
                                <td colSpan="3" className="p-0">
                                  <Table className="table-borderless table-sm table-nowrap align-middle mb-0">
                                    <tbody>
                                      <tr>
                                        <th scope="row">No Transaksi</th>
                                        <td>
                                          <Input name="transaction_no" id="transaction_no" className="form-control" placeholder="[ Automatic ]" type="text"
                                            value={validation.values.transaction_no}
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            invalid={validation.touched.transaction_no && validation.errors.transaction_no ? true : false} />
                                          {validation.touched.transaction_no && validation.errors.transaction_no && (
                                            <small className="text-danger" type="invalid">{validation.errors.transaction_no}</small>
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Transfer Destination</th>
                                        <td>
                                          <Select name="branch" placeholder="Select Warehouse"
                                            value={validation.values.branch}
                                            onChange={(e) => { validation.setFieldValue("branch", e); }}
                                            options={branchList}></Select>
                                          {validation.touched.branch && validation.errors.branch && (
                                            <small className="text-danger" type="invalid">{validation.errors.branch}</small>
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Shipping Carrier</th>
                                        <td>
                                          <Select name="shipment_carrier" placeholder="Shipping Carrier"
                                            value={validation.values.shipment_carrier}
                                            onChange={(e) => { validation.setFieldValue("shipment_carrier", e); }}
                                            options={shipmentCarrierList}></Select>
                                          {validation.touched.shipment_carrier && validation.errors.shipment_carrier && (
                                            <small className="text-danger" type="invalid">{validation.errors.shipment_carrier}</small>
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Shipping Method</th>
                                        <td>
                                          <Select name="shipment_method" placeholder="Method"
                                            value={validation.values.shipment_method}
                                            onChange={(e) => { validation.setFieldValue("shipment_method", e); }}
                                            options={shipmentMethodList}></Select>
                                          {validation.touched.shipment_method && validation.errors.shipment_method && (
                                            <small className="text-danger" type="invalid">{validation.errors.shipment_method}</small>
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Shipping Amount</th>
                                        <td>
                                          <Input name="shipment_amount" id="shipment_amount" className="form-control" placeholder="Enter shipping price" type="text"
                                            value={validation.values.shipment_amount}
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            invalid={validation.touched.shipment_amount && validation.errors.shipment_amount ? true : false} />
                                          {validation.touched.shipment_amount && validation.errors.shipment_amount && (
                                            <small className="text-danger" type="invalid">{validation.errors.shipment_amount}</small>
                                          )}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button type="button" className="btn btn-light" onClick={() => { setModal(false); }}> Close </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            {!!isEdit ? "Update" : "Add Transfer"}
                            {loading ? (<Spinner size="sm" className="flex-shrink-0" role="status"> Loading... </Spinner>) : ""}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalHistory" isOpen={modalHistory} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleHistory}>Transfer Histories</ModalHeader>
                  <ModalBody>
                    <div className="profile-timeline">
                      <div></div>
                      <div className="accordion accordion-flush" id="todayExample">
                        {info && info.transfer_history && info.transfer_history.map((item, i) => {
                          return (
                            <div key={i} className="accordion-item border-0">
                              <div className="accordion-header">
                                <button className="accordion-button p-2 shadow-none" type="button" id="headingOne" >
                                  <div className="d-flex">
                                    <div className="flex-shrink-0">
                                      {
                                        item.transfer_history_createdby && item.transfer_history_createdby.employee_image && item.transfer_history_createdby.employee_image.path ?
                                          <img src={process.env.REACT_APP_API_URL + "/files/" + item.transfer_history_createdby.employee_image.path} alt="" className="rounded-circle avatar-xs" />
                                          :
                                          <div className="flex-shrink-0 avatar-xs">
                                            <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">
                                              {item.transfer_history_createdby.name.charAt(0)}
                                            </div>
                                          </div>
                                      }
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                      <h6 className="fs-14 mb-1">{item.transfer_history_createdby.name}</h6>
                                      <p className="fw-normal text-muted mb-1">Change transfer status to <span className="fw-semibold text-info">{item.transfer_history_status.name}</span> with note:</p>
                                      <p className="fw-normal mb-1">{item.notes || "-"}</p>
                                      <small className="text-muted">{moment(item.createdat, "YYYY/MM/DD HH:mm:ss").fromNow()}</small>
                                    </div>
                                  </div>
                                </button>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button type="button" className="btn btn-light" onClick={() => { setModalHistory(false); }}>Tutup</button>
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalApprove" isOpen={modalApprove} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleApprove}>Add Product Approve</ModalHeader>
                  <Form onSubmit={(e) => { e.preventDefault(); validationApprove.handleSubmit(); return false; }}>
                    <ModalBody>
                      <div className="mt-2 text-center">
                        <lord-icon
                          src="https://cdn.lordicon.com/puvaffet.json"
                          trigger="loop"
                          colors="primary:#f7b84b,secondary:#f06548"
                          style={{ width: "100px", height: "100px" }}></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                          <h4>Are you sure ?</h4>
                          <p className="text-muted mx-4 mb-0">
                            Are you sure you want to {transfer && transfer.statusTransferId === 3 ? "Processed" : "Shipped"} data
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="mt-3 col-lg-12">
                          <Input name="approval_note" id="approval_note-field" className="form-control" placeholder="Enter Notes If Any" rows={4} type="textarea"
                            onChange={validationApprove.handleChange}
                            onBlur={validationApprove.handleBlur} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button type="button" className="btn btn-light"
                          onClick={() => { setModalApprove(false); }}>Tutup</button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Submit</span>
                            {loading ? (<Spinner size="sm" className="flex-shrink-0" role="status">Loading...</Spinner>) : ("")}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>Transfer Detail</ModalHeader>
                  <ModalBody>
                    <Row id="printThis">
                      <Col lg={12}>
                        <CardHeader className="border-bottom-dashed p-4">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                              <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" />
                              <div className="mt-sm-3 mt-3">
                                <h6 className="text-uppercase fw-semibold">{info.transfer_company && info.transfer_company.name}</h6>
                              </div>
                            </div>
                          </div>
                        </CardHeader>
                        <CardBody className="p-4">
                          <Row className="g-3">
                            <Col lg={3} xs={3}>
                              <p className="text-muted mb-2 text-uppercase fw-semibold">Transfer No</p>
                              <h5 className="fs-14 mb-0">#<span id="invoice-no">{info.transaction_no}</span></h5>
                            </Col>
                            <Col lg={3} xs={3}>
                              <p className="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                              <h5 className="fs-14 mb-0">
                                <span id="invoice-date">{handleValidDate(info.transactionat)}</span>
                              </h5>
                            </Col>
                            <Col lg={3} xs={3}>
                              <p className="text-muted mb-2 text-uppercase fw-semibold">Ship From</p>
                              <p className="mb-1 fw-semibold">{info.transfer_from && info.transfer_from.branch_name}</p>
                              <p className="mb-1 ">
                                <span>
                                  {info.transfer_from && info.transfer_from.branch_address[0] && info.transfer_from.branch_address[0].description}, &nbsp;
                                  {info.transfer_from && info.transfer_from.branch_address[0] && info.transfer_from.branch_address[0].av && info.transfer_from.branch_address[0].av.vc.city_name}
                                </span>
                              </p>
                              <p className="mb-1">
                                <span>
                                  {info.transfer_from && info.transfer_from.branch_address[0] && info.transfer_from.branch_address[0].av && info.transfer_from.branch_address[0].av.vp.province_name}  &nbsp;
                                  {info.transfer_from && info.transfer_from.branch_address[0] && info.transfer_from.branch_address[0].av && info.transfer_from.branch_address[0].av.zip} &nbsp;
                                </span>
                              </p>
                            </Col>
                            <Col lg={3} xs={3}>
                              <p className="text-muted mb-2 text-uppercase fw-semibold">Ship to</p>
                              <p className="mb-1 fw-semibold">{info.transfer_to && info.transfer_to.branch_name}</p>
                              <p className="mb-1">
                                <span>
                                  {info.transfer_to && info.transfer_to.branch_address[0] && info.transfer_to.branch_address[0].description}, &nbsp;
                                  {info.transfer_to && info.transfer_to.branch_address[0] && info.transfer_to.branch_address[0].av && info.transfer_to.branch_address[0].av.vc.city_name}
                                </span>
                              </p>
                              <p className="mb-0">
                                <span>
                                  {info.transfer_to && info.transfer_to.branch_address[0] && info.transfer_to.branch_address[0].av && info.transfer_to.branch_address[0].av.vp.province_name}  &nbsp;
                                  {info.transfer_to && info.transfer_to.branch_address[0] && info.transfer_to.branch_address[0].av && info.transfer_to.branch_address[0].av.zip} &nbsp;
                                </span>
                              </p>
                            </Col>
                          </Row>
                        </CardBody>
                        <CardBody className="p-4">
                          <div className="table-responsive">
                            <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                              <thead>
                                <tr className="table-active">
                                  <th scope="col" style={{ width: "50px" }}>#</th>
                                  <th scope="col">Detail Produk</th>
                                  <th scope="col">Rate</th>
                                  <th scope="col">Quantity</th>
                                  <th scope="col" className="text-end"> Amount</th>
                                </tr>
                              </thead>
                              <tbody id="products-list">
                                {transferDetailItem.map((o, i) => {
                                  return (
                                    <tr key={i} id={i} className="product">
                                      <th scope="row" className="product-id">{i + 1}</th>
                                      <td className="text-start">{transferDetailItem[i].item.label}</td>
                                      <td>{transferDetailItem[i].amount}</td>
                                      <td>{transferDetailItem[i].quantity}</td>
                                      <td className="text-end">{currencyFormat(transferDetailItem[i].amount * transferDetailItem[i].quantity)}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>
                          <div className="border-top border-top-dashed mt-2">
                            <Table className="table table-borderless table-nowrap align-middle mb-0 ms-auto" style={{ width: "250px" }}>
                              <tbody>
                                <tr>
                                  <td>Sub Total</td>
                                  <td className="text-end">{currencyFormat(subTotal)}</td>
                                </tr>
                                <tr>
                                  <td>Biaya Kirim</td>
                                  <td className="text-end">{currencyFormat(ship)}</td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                          <div className="mt-3">
                            <h6 className="text-muted text-uppercase fw-semibold mb-3">Shipment Details:</h6>
                            <p className="text-muted mb-1">
                              Shipping Via:            <span className="fw-medium" id="card-number">{info.transfer_shipment_method && info.transfer_shipment_method.method_name} - {info.transfer_shipment_carrier && info.transfer_shipment_carrier.carrier_name}</span>
                            </p>
                          </div>
                          <div className="mt-4">
                            <div className="alert alert-info">
                              <p className="mb-0">
                                <span className="fw-semibold">NOTES:</span>
                                <span id="note">{info.description}</span>
                              </p>
                            </div>
                          </div>
                        </CardBody>
                      </Col>
                    </Row>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button type="button" className="btn btn-light" onClick={() => { setModalDetail(false); }}> Close </button>
                      <button type="submit" className="btn btn-info" onClick={() => { printInvoice(document.getElementById("printThis")) }}>Print Document</button>
                      {info.statusId === 1 && (<button type="submit" className="btn btn-success" onClick={() => {
                        info.statusTransferId = 2;
                        setTransfer(info);
                        toggleApprove();
                      }}>Confirmed Transfer</button>)}
                      {info.statusId === 2 && (<button type="submit" className="btn btn-warning" onClick={() => {
                        info.statusTransferId = 3;
                        setTransfer(info);
                        toggleApprove();
                      }}>Processed Transfer</button>)}
                    </div>
                  </div>
                </Modal>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container >
    </div >
  );
};

export default Transfer;